export enum MasterDataQueries {
  MasterDataHierarchies = 'masterDataHierarchies',
  MasterDataHierarchy = 'masterDataHierarchy',
  MasterDataHierarchyList = 'masterDataHierarchyList',
  MasterDataCountArchived = 'masterDataCountArchived',
}
